import React from "react";
import passed from "../../../../assets/images/passed.png";
import fraud from "../../../../assets/images/fraud.png";
import fraudCheck from "../../../../assets/images/fraudCheck.png";
export default function FraudCheck({ fraudDetails }) {
  return (
    <div
      style={{
        border: "1px solid #AEBBD7",
        borderRadius: "1em",
        width: "50%",
        margin: "1em",
        backgroundColor: "#F6F9FF",
        boxShadow: "0px 0px 2px 2px  #f0f0f0",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-around" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "1em",
            width: "100%",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <p
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              fontFamily: "Outfit",
            }}
          >
            <img style={{ marginRight: "0.5em" }} src={fraudCheck} />
            Fraud Checks
          </p>
        </div>
      </div>
      <div style={{ overflowY: "scroll" }}>
        <div style={{ padding: "1em", borderBottom: "1px solid #D0D0D0" }}>
          <p
            style={{
              color: "#d32028",
              fontSize: "20px",
              fontWeight: "bold",
              marginLeft: "2em",
            }}
          >
            Identified Fraud Indicators
          </p>
          {fraudDetails?.flags ? (
            fraudDetails?.flags?.bounceDetected ? (
              <p style={{ marginLeft: "2em" }}>
                <img style={{ marginRight: "1em" }} src={fraud} />
                Bounce Detected
              </p>
            ) : (
              <p style={{ marginLeft: "3em" }}>None</p>
            )
          ) : null}
          {fraudDetails?.flags?.chequeBounceDetected ? (
            <p style={{ marginLeft: "2em", color: "#d32028" }}>
              <img style={{ marginRight: "1em" }} src={fraud} />
              Cheque Bounce Detected
            </p>
          ) : null}
          {fraudDetails?.flags?.bounceDetected ? (
            <p style={{ marginLeft: "2em" }}>
              <img style={{ marginRight: "1em" }} src={fraud} />
              Bank Penalties Detected
            </p>
          ) : null}
          {fraudDetails?.flags?.bounceDetected ? (
            <p style={{ marginLeft: "2em" }}>
              <img style={{ marginRight: "1em" }} src={fraud} />
              Reversal Detected
            </p>
          ) : null}
        </div>
        <div style={{ padding: "1em", height: "10em" }}>
          <p
            style={{
              color: "#4bb543",
              fontSize: "20px",
              fontWeight: "bold",
              marginLeft: "2em",
            }}
          >
            Passed Fraud Indicators
          </p>
          {fraudDetails?.flags ? (
            fraudDetails?.flags?.bounceDetected === false ? (
              <p style={{ marginLeft: "3em" }}>
                <img style={{ marginRight: "1em" }} src={passed} />
                No Bounce Detected
              </p>
            ) : null
          ) : (
            <p style={{}}>No Indicators Found</p>
          )}
          {fraudDetails?.flags?.chequeBounceDetected === false ? (
            <p style={{ marginLeft: "3em" }}>
              <img style={{ marginRight: "1em" }} src={passed} />
              No Cheque Bounce Detected
            </p>
          ) : null}
          {fraudDetails?.flags?.bankPenaltiesDetected === false ? (
            <p style={{ marginLeft: "3em" }}>
              <img style={{ marginRight: "1em" }} src={passed} />
              No Bank Penalties Detected
            </p>
          ) : null}
          {fraudDetails?.flags?.reversalDetected === false ? (
            <p style={{ marginLeft: "3em" }}>
              <img style={{ marginRight: "1em" }} src={passed} />
              No Reversal Detected
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
}
